import gql from 'graphql-tag';

import { PrintAssetDetails } from '../fragments/print-assets';

export const printAssetCreate = gql`
  mutation printAssetCreate($input: PrintAssetCreateInput!) {
    printAssetCreate(input: $input) {
      print_asset {
        ...PrintAssetDetails
      }
    }
  }
  ${PrintAssetDetails}
`;

export const printAssetUpdate = gql`
  mutation printAssetUpdate($input: PrintAssetUpdateInput!) {
    printAssetUpdate(input: $input) {
      print_asset {
        ...PrintAssetDetails
      }
    }
  }
  ${PrintAssetDetails}
`;

export const printAssetDelete = gql`
  mutation printAssetDelete($input: PrintAssetDeleteInput!) {
    printAssetDelete(input: $input) {
      success
    }
  }
`;
